var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPaperTable = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3 6.8L16.36 2.08C15.79 1.4 14.95 1 14.06 1H6C4.34 1 3 2.34 3 4V20C3 21.66 4.34 23 6 23H18C19.66 23 21 21.66 21 20V8.72C21 8.02 20.75 7.34 20.3 6.8ZM19 20C19 20.55 18.55 21 18 21H6C5.45 21 5 20.55 5 20V4C5 3.45 5.45 3 6 3H14.06C14.36 3 14.64 3.13 14.83 3.36L18.77 8.08C18.92 8.26 19 8.49 19 8.72V20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7H8C6.9 7 6 7.9 6 9V18C6 19.1 6.9 20 8 20H16C17.1 20 18 19.1 18 18V9C18 7.9 17.1 7 16 7ZM16 10H12V9H16V10ZM16 12V14H12V12H16ZM8 9H10V10H8V9ZM8 12H10V14H8V12ZM8 16H10V18H8V16ZM12 18V16H16V18H12Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPaperTable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconPaperTable.c30f1caa882981885b3f2a4b6142cc34.svg";